module.exports = __webpack_public_path__ + "img/features-1.518136c9.png";